/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as MsDyn365 from '@msdyn365-commerce/core';
import * as React from 'react';
import { ILxsInformationHeaderViewProps } from './lxs-information-header';

export default (props: ILxsInformationHeaderViewProps) => {
    const CLASS_NAME = 'lxs-information-header';
    const { config, context } = props;
    const { heading, leftColumnContent, rightColumnContent } = config;

    const handleHeadingTextChange = (event: MsDyn365.ContentEditableEvent) => (config.heading!.headingText = event.target.value);

    return (
        <div className={`${CLASS_NAME}__content-wrapper`}>
            <div className={`${CLASS_NAME}__content-box`}>
                {heading?.headingText && (
                    <MsDyn365.Text
                        className={`${CLASS_NAME}__content-box-heading`}
                        text={heading.headingText}
                        tag={heading.tag || 'h1'}
                        editProps={{ onEdit: handleHeadingTextChange, requestContext: context.request }}
                    />
                )}

                <div className={`${CLASS_NAME}__content-box-columns`}>
                    <div className={`${CLASS_NAME}__content-box-columns-left`}>
                        {leftColumnContent && <MsDyn365.RichTextComponent text={leftColumnContent} />}
                    </div>

                    <div className={`${CLASS_NAME}__content-box-columns-right`}>
                        {rightColumnContent && <MsDyn365.RichTextComponent text={rightColumnContent} />}
                    </div>
                </div>
            </div>
        </div>
    );
};
